import flagCA from "~/assets/images/flag-ca.svg";
import flagUK from "~/assets/images/flag-uk.svg";
import flagUS from "~/assets/images/flag-us.svg";

const locales = {
  us: {
    country: "United States",
    country_abbreviation: "US",
    demonym: "Americans",
    enabled: true,
    flag: flagUS,
    path: "",
    year: process.env.REACT_APP_SURVEY_YEAR,
  },
  ca: {
    country: "Canada",
    country_abbreviation: "CA",
    demonym: "Canadians",
    enabled: Boolean(
      process.env.REACT_APP_SURVEY_ENABLE_CA === "true" ?? false,
    ),
    flag: flagCA,
    path: "ca",
    year: process.env.REACT_APP_SURVEY_YEAR_CA,
  },
  uk: {
    country: "United Kingdom",
    country_abbreviation: "UK",
    demonym: "Brits",
    enabled: Boolean(process.env.REACT_APP_SURVEY_ENABLE_UK === "true"),
    flag: flagUK,
    path: "uk",
    year: process.env.REACT_APP_SURVEY_YEAR_UK,
  },
};

export const defaultLocale = "us";

export const enabledLocales = Object.entries(locales).filter(
  ([_, l]) => l.enabled,
);

// Derived from every locale, not just the enabled ones: a locale whose survey isn't out yet
// still owns its URL prefix (e.g. /uk while the UK shows a Coming Soon page and serves its
// previous survey's Data Explorer), and links on those pages must stay inside it.
export const nonUSPaths = Object.values(locales)
  .map((l) => l.path)
  .filter((f) => f !== "");

export const localeKeyForPath = (path) =>
  Object.keys(locales).find((key) => locales[key].path === path);

export default locales;
